module.exports = __webpack_public_path__ + "static/media/BannerApi_LaptopCripto.42fc92c4.png";